import { Component, OnInit, TemplateRef } from '@angular/core';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { FormControl } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { JobsService } from 'src/app/services/jobs.service';
import { NotificationService } from 'src/app/services/notification.service';

export interface Role {
  value: string;
  viewValue: string;
}

@Component({
  selector: 'app-jobdetail',
  templateUrl: './jobdetail.component.html',
  styleUrls: ['./jobdetail.component.scss']
})
export class JobdetailComponent implements OnInit {
  loader: boolean = false;
  jobDetail: any = null;
  jobId: string = '';

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private jobService: JobsService,
    private ns: NotificationService
  ) { }

  /**
   * To initialize data check permisssion and get job details
   */
  ngOnInit() {
    // Get jobId from query params
    this.route.queryParams.subscribe(params => {
      this.jobId = params['job_id'] || '';
      if (this.jobId) {
        this.getJobDetail();
      }
    });
  }

  /**
   * To get applied job details
   */
  getJobDetail() {
    this.loader = true;
    this.jobService.getJobById(this.jobId).subscribe({
      next: (res) => {
        this.jobDetail = res.job_data;
        this.loader = false;
      },
      error: (err) => {
        this.loader = false;
        this.ns.showNotification('error', err.message);
      }
    });
  }
}
